/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Empty } from '../models/empty';
import { ubereatsOauthTokenGet } from '../fn/ubereats/ubereats-oauth-token-get';
import { UbereatsOauthTokenGet$Params } from '../fn/ubereats/ubereats-oauth-token-get';
import { ubereatsOauthTokenPost } from '../fn/ubereats/ubereats-oauth-token-post';
import { UbereatsOauthTokenPost$Params } from '../fn/ubereats/ubereats-oauth-token-post';
import { ubereatsStoreProvisionAggregatorStoreIdGet } from '../fn/ubereats/ubereats-store-provision-aggregator-store-id-get';
import { UbereatsStoreProvisionAggregatorStoreIdGet$Params } from '../fn/ubereats/ubereats-store-provision-aggregator-store-id-get';
import { ubereatsStoreProvisionAggregatorStoreIdPost } from '../fn/ubereats/ubereats-store-provision-aggregator-store-id-post';
import { UbereatsStoreProvisionAggregatorStoreIdPost$Params } from '../fn/ubereats/ubereats-store-provision-aggregator-store-id-post';
import { UbereatsStoreProvisionResponse } from '../models/ubereats-store-provision-response';
import { UbereatsTokenValidationResponse } from '../models/ubereats-token-validation-response';

@Injectable({ providedIn: 'root' })
export class UbereatsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ubereatsOauthTokenGet()` */
  static readonly UbereatsOauthTokenGetPath = '/ubereats/oauth/token';

  /**
   * Validates API token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ubereatsOauthTokenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ubereatsOauthTokenGet$Response(params: UbereatsOauthTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UbereatsTokenValidationResponse>> {
    return ubereatsOauthTokenGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Validates API token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ubereatsOauthTokenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ubereatsOauthTokenGet(params: UbereatsOauthTokenGet$Params, context?: HttpContext): Observable<UbereatsTokenValidationResponse> {
    return this.ubereatsOauthTokenGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UbereatsTokenValidationResponse>): UbereatsTokenValidationResponse => r.body)
    );
  }

  /** Path part for operation `ubereatsOauthTokenPost()` */
  static readonly UbereatsOauthTokenPostPath = '/ubereats/oauth/token';

  /**
   * Exchange an Ubereats authorization code for an API token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ubereatsOauthTokenPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  ubereatsOauthTokenPost$Response(params: UbereatsOauthTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return ubereatsOauthTokenPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Exchange an Ubereats authorization code for an API token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ubereatsOauthTokenPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ubereatsOauthTokenPost(params: UbereatsOauthTokenPost$Params, context?: HttpContext): Observable<Empty> {
    return this.ubereatsOauthTokenPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `ubereatsStoreProvisionAggregatorStoreIdGet()` */
  static readonly UbereatsStoreProvisionAggregatorStoreIdGetPath = '/ubereats/storeProvision/{aggregatorStoreId}';

  /**
   * Gets store provision.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ubereatsStoreProvisionAggregatorStoreIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ubereatsStoreProvisionAggregatorStoreIdGet$Response(params: UbereatsStoreProvisionAggregatorStoreIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UbereatsStoreProvisionResponse>> {
    return ubereatsStoreProvisionAggregatorStoreIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets store provision.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ubereatsStoreProvisionAggregatorStoreIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ubereatsStoreProvisionAggregatorStoreIdGet(params: UbereatsStoreProvisionAggregatorStoreIdGet$Params, context?: HttpContext): Observable<UbereatsStoreProvisionResponse> {
    return this.ubereatsStoreProvisionAggregatorStoreIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UbereatsStoreProvisionResponse>): UbereatsStoreProvisionResponse => r.body)
    );
  }

  /** Path part for operation `ubereatsStoreProvisionAggregatorStoreIdPost()` */
  static readonly UbereatsStoreProvisionAggregatorStoreIdPostPath = '/ubereats/storeProvision/{aggregatorStoreId}';

  /**
   * Send POST request to Ubereats to provision the store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ubereatsStoreProvisionAggregatorStoreIdPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ubereatsStoreProvisionAggregatorStoreIdPost$Response(params: UbereatsStoreProvisionAggregatorStoreIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return ubereatsStoreProvisionAggregatorStoreIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Send POST request to Ubereats to provision the store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ubereatsStoreProvisionAggregatorStoreIdPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ubereatsStoreProvisionAggregatorStoreIdPost(params: UbereatsStoreProvisionAggregatorStoreIdPost$Params, context?: HttpContext): Observable<Empty> {
    return this.ubereatsStoreProvisionAggregatorStoreIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

}
